import { render, staticRenderFns } from "./eventMessage.vue?vue&type=template&id=6b135d10"
import script from "./eventMessage.vue?vue&type=script&lang=js"
export * from "./eventMessage.vue?vue&type=script&lang=js"
import style0 from "./eventMessage.vue?vue&type=style&index=0&id=6b135d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports